import type { DecorationScreenSchema } from "./types";

export const orderTypeSchema = {
	background: { css: [] },
	content: { css: [], children: ["title", "glow"] },
	glow: { css: [], children: ["variants"] },
	lang_button: { css: ["open"] },
	lang_chevron: { visible: true },
	lang_icon: { visible: true },
	lang_label: { css: [] },
	lang_picker: { css: [] },
	lang_popup: { css: [] },
	modal: { css: [], children: ["background", "lang_picker", "content"] },
	title: { css: [] },
	variant: { css: ["active"], children: ["variant_media", "variant_name"] },
	variant_image: { css: [] },
	variant_media: { css: [], children: ["variant_image"] },
	variant_name: { css: [] },
	variants: { css: [], children: ["variant"] },
} as const satisfies DecorationScreenSchema;
